module.exports = __webpack_public_path__ + "img/operation-4280-bg.e6096c52.png";